<template>
  <div class="slider-back">
    <!--环图片-->
    <div class="img-box">
      <div class="prop-up"></div>
      <img src="@/assets/img/circle.png" class="circle" alt="">
    </div>
    <div>
      <!--题目-->
      <div class="subject">
        <div>{{ $t('natureQue1_1') }}</div>
      </div>
      <!--选项-->
      <div style="margin:calc(0.073 * var(--body-height)) 0 0 30px;">
        <el-radio-group v-model="natureAnswer">
          <el-radio :label="$t('leaf1')">{{$t('leaf1')}}</el-radio>
          <el-radio :label="$t('leaf2')">{{$t('leaf2')}}</el-radio>
          <el-radio :label="$t('leaf3')">{{$t('leaf3')}}</el-radio><br>
          <el-radio :label="$t('notSure')">{{$t('notSure')}}</el-radio>
        </el-radio-group>
      </div>
      <!--题目跳转-->
      <div class="subject-jump">
        <span @click="prevClick" class="prev-btn"><i class="icon-left"></i> {{ $t('preQues') }}</span>
        <el-button @click="nextClick"
                   :disabled="countNumber!=0"
                   style="width:160px;"
                   type="primary">{{ $t('nextQues') }} <i class="icon-right"></i> ({{ countNumber }}s)
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "nature1_1",
  data() {
    return {
      //自然题答案
      natureAnswer: '',
      timer: null,
      countNumber: 0
    }
  },
  computed: {
    ...mapGetters([
      'natureAnswerArr'
    ]),
  },
  mounted(){
    //计时器
    this.countdown()
    this.$store.commit('SET_ANSWER_PERCENT', 14 * 100 / 22)
    this.natureAnswer = this.natureAnswerArr[1][1]
  },
  methods: {

    /**
     * 上一题
     */
    prevClick() {
      this.$router.push('/nature1')
    },

    /**
     * 下一题
     */
    nextClick() {
      if (this.natureAnswer === '') {
        this.$toast(this.$t('selectOne'));
        return;
      }
      //保存答案
      this.natureAnswerArr[1][1] = this.natureAnswer
      this.$router.push('/nature2')
    },

    /**
     * 验证码倒计时
     */
    countdown() {
      let that = this;
      this.countNumber = 2;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(function () {
        if (that.countNumber === 0) {
          clearInterval(this.timer);
        } else {
          that.countNumber--;
        }
      }, 1000);
    }
  }
}
</script>


<style scoped lang="less">

</style>